/* eslint no-undef: 0 */
// import 'babel-polyfill';

// Bootstrap dependencies
import 'popper.js';
// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/util';

// Vendor
import 'slick-carousel/slick/slick.min.js';
// import 'fullpage.js/dist/fullpage.min.js';
import 'headspace/dist/headspace.js';

// Custom Scripts
import './main-nav-controller';
// import './fullpage';
import './scripts';



// WEBPACK FOOTER //
// ./src/js/app.js